import { createRoot } from 'react-dom/client'
import { StrictMode, useContext } from 'react'
import { Provider } from 'react-redux'
import { GoogleOAuthProvider } from '@react-oauth/google'
import { ConfigProvider, theme } from 'antd'

import './index.css'
import { AppProvider } from './context/AppProvider'
import AppContext from './context/AppContext'
import store from './store'
import { ToastProvider } from './components/ui/toast/Toast'
import AppRouter from './router'

const App = () => {
  const { config: { isDark } } = useContext(AppContext)
  
  return (
    <ConfigProvider 
      theme={{ 
        algorithm: isDark ? theme.darkAlgorithm : theme.defaultAlgorithm,
        token: {
          fontFamily: 'Inter, sans-serif',
          ...(isDark ? {
            colorBgElevated: '#121e2d',
            colorBgContainer: '#121e2d',
          } : {})
        }
      }}
    >
      <ToastProvider position="bottom-right">
        <AppRouter />
      </ToastProvider>
    </ConfigProvider>
  )
}

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <GoogleOAuthProvider clientId={import.meta.env.VITE_GOOGLE_CLIENT_ID}>
      <Provider store={store}>
        <AppProvider>
          <App />
        </AppProvider>
      </Provider>
    </GoogleOAuthProvider>
  </StrictMode>
)
